export default langsData => [
  {
    path: '/paygame/',
    name: 'paygame',
    component: () =>
      import(/* webpackChunkName: "paygame" */ '@/views/paygame/index.vue'),
    meta: {
      title: langsData['paygame'].title
    }
  },
  {
    path: '/paygame_history/',
    name: 'paygame_history',
    component: () =>
      import(/* webpackChunkName: "paygame" */ '@/views/paygame/order-history.vue'),
    meta: {
      title: langsData['paygame'].title
    }
  }
]
